"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceTrendType = exports.WeightUnit = exports.HorseSex = exports.ContentType = exports.PoolStatus = exports.PoolSelectionStatus = exports.PoolBetStatus = exports.RunnerStatus = exports.RaceStatus = void 0;
var RaceStatus;
(function (RaceStatus) {
    RaceStatus[RaceStatus["Future"] = 1] = "Future";
    RaceStatus[RaceStatus["Deferred"] = 2] = "Deferred";
    RaceStatus[RaceStatus["Running"] = 3] = "Running";
    RaceStatus[RaceStatus["Finished"] = 4] = "Finished";
    RaceStatus[RaceStatus["ResultConfirmed"] = 5] = "ResultConfirmed";
    RaceStatus[RaceStatus["Abandoned"] = 6] = "Abandoned";
    RaceStatus[RaceStatus["Closed"] = 7] = "Closed";
})(RaceStatus || (exports.RaceStatus = RaceStatus = {}));
;
var RunnerStatus;
(function (RunnerStatus) {
    RunnerStatus[RunnerStatus["Available"] = 1] = "Available";
    RunnerStatus[RunnerStatus["Withdrawn"] = 2] = "Withdrawn";
    RunnerStatus[RunnerStatus["NeverLivened"] = 3] = "NeverLivened";
})(RunnerStatus || (exports.RunnerStatus = RunnerStatus = {}));
;
var PoolBetStatus;
(function (PoolBetStatus) {
    PoolBetStatus[PoolBetStatus["Unknown"] = 1] = "Unknown";
    PoolBetStatus[PoolBetStatus["NotPlaced"] = 2] = "NotPlaced";
    PoolBetStatus[PoolBetStatus["Active"] = 3] = "Active";
    PoolBetStatus[PoolBetStatus["SettledWon"] = 4] = "SettledWon";
    PoolBetStatus[PoolBetStatus["SettledLost"] = 5] = "SettledLost";
    PoolBetStatus[PoolBetStatus["SettledUnclaimed"] = 6] = "SettledUnclaimed";
    PoolBetStatus[PoolBetStatus["SettledVoid"] = 7] = "SettledVoid";
    PoolBetStatus[PoolBetStatus["BeingCancelled"] = 8] = "BeingCancelled";
    PoolBetStatus[PoolBetStatus["Cancelled"] = 9] = "Cancelled";
})(PoolBetStatus || (exports.PoolBetStatus = PoolBetStatus = {}));
;
var PoolSelectionStatus;
(function (PoolSelectionStatus) {
    PoolSelectionStatus[PoolSelectionStatus["Available"] = 1] = "Available";
    PoolSelectionStatus[PoolSelectionStatus["Withdrawn"] = 2] = "Withdrawn";
    PoolSelectionStatus[PoolSelectionStatus["NeverLivened"] = 3] = "NeverLivened";
})(PoolSelectionStatus || (exports.PoolSelectionStatus = PoolSelectionStatus = {}));
;
var PoolStatus;
(function (PoolStatus) {
    PoolStatus[PoolStatus["AvailableForBetting"] = 1] = "AvailableForBetting";
    PoolStatus[PoolStatus["Closed"] = 2] = "Closed";
    PoolStatus[PoolStatus["Scratched"] = 3] = "Scratched";
    PoolStatus[PoolStatus["Settled"] = 4] = "Settled";
})(PoolStatus || (exports.PoolStatus = PoolStatus = {}));
;
var ContentType;
(function (ContentType) {
    ContentType[ContentType["Hypertext"] = 1] = "Hypertext";
    ContentType[ContentType["Video"] = 2] = "Video";
    ContentType[ContentType["Audio"] = 3] = "Audio";
    ContentType[ContentType["Special"] = 4] = "Special";
})(ContentType || (exports.ContentType = ContentType = {}));
;
var HorseSex;
(function (HorseSex) {
    HorseSex[HorseSex["Mare"] = 1] = "Mare";
    HorseSex[HorseSex["Filly"] = 2] = "Filly";
    HorseSex[HorseSex["Gelding"] = 3] = "Gelding";
    HorseSex[HorseSex["Colt"] = 4] = "Colt";
    HorseSex[HorseSex["Horse"] = 5] = "Horse";
    HorseSex[HorseSex["Ridgling"] = 6] = "Ridgling";
})(HorseSex || (exports.HorseSex = HorseSex = {}));
;
var WeightUnit;
(function (WeightUnit) {
    WeightUnit[WeightUnit["ImperialPound"] = 1] = "ImperialPound";
    WeightUnit[WeightUnit["Kilogram"] = 2] = "Kilogram";
})(WeightUnit || (exports.WeightUnit = WeightUnit = {}));
;
var PriceTrendType;
(function (PriceTrendType) {
    PriceTrendType[PriceTrendType["Increasing"] = 1] = "Increasing";
    PriceTrendType[PriceTrendType["Decreasing"] = 2] = "Decreasing";
    PriceTrendType[PriceTrendType["Unchanged"] = 3] = "Unchanged";
    PriceTrendType[PriceTrendType["Unknown"] = 4] = "Unknown";
})(PriceTrendType || (exports.PriceTrendType = PriceTrendType = {}));
;
